import { createImage } from './image-crop.helper'

export const parseImageFileToBase64 = (file: any): Promise<any> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file)

    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}

export const parseImageUrlToBase64 = async (url: string): Promise<string> => {
  const img = await createImage(url)

  const canvas = document.createElement('canvas')
  canvas.width = img.width
  canvas.height = img.height

  const ctx = canvas.getContext('2d')
  ctx?.drawImage(img, 0, 0)
  return canvas.toDataURL('image/png').replace(/^data:image\/(png|jpg);base64,/, '')
}
